module.exports = __webpack_public_path__ + "static/img/mens_leveranciers_2.3ed5533.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_leveranciers_2.svg
// module id = JY/K
// module chunks = 0